import { useCallback } from 'react';
// @ts-expect-error untyped module reference-resolvers
import { AUTOMATION_PLATFORM_WORKFLOWS } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped module customer-data-reference-ui-components
import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName';
import { flowUrl } from 'automation-ui-routing/workflowsUrls';
import { getFlowName } from 'automation-ui-flow-core/flow/flowUtils';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Don't use this component directly. Instead, use the
 * `WorkflowName` component and pass flowSourceType="PLATFORM"
 *
 * Example:
 *   <PlatformFlowName id="123" />
 * Renders as:
 *   My Flow Name
 */
const PlatformFlowName = ({
  id,
  messageKey,
  href = flowUrl(id)
}) => /*#__PURE__*/_jsx(ReferenceName, {
  id: id,
  referenceObjectType: AUTOMATION_PLATFORM_WORKFLOWS,
  onResolved: useCallback(({
    reference
  }) => getFlowName(reference.referencedObject.toJS()), []),
  href: href,
  messageKey: messageKey
});
export default PlatformFlowName;